import { IUserInfo } from '~src/ts/models/IUserInfo';

import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { IListFetcher } from '../../ts/fetchers/IListFetcher';
import { ServerApiMapper} from '../../ts/helpers/ServerModelHelper';
import { ExplorableItemType, ExplorableItemTypeValue } from '../../ts/models/ContentType';
import { ViewStatFields } from '../../ts/models/ContentTypes';
import { IRecentContentInfo } from '../../ts/models/IRecentContentInfo';
import { OrderKeys } from '../../ts/models/OrderKeys';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';
import { GetDetailedRecentsRequest } from '../../ts/ServerApi/requests/GetDetailedRecentsRequest';
import { ILeafFilterClause } from '../../ts/ServerApi/types/IFilterClause';
import { IOrderClause } from '../../ts/ServerApi/types/IOrderClause';

class RecentsResource {

  private getRecentViews: IListFetcher<IRecentContentInfo> = new WebClientListResourceFetcher(
    GetDetailedRecentsRequest, ServerApiMapper.recentItems);

  private getRecentUsersFetcher: IListFetcher<IUserInfo> = new WebClientListResourceFetcher(
    GetDetailedRecentsRequest, ServerApiMapper.recentUniqueUsers);

  public all(contentTypes: ReadonlyArray<ExplorableItemType>, additionalFilterClauses?: ILeafFilterClause[]): ResourceQuery<IRecentContentInfo> {
    const objectTypes: string[] = this.getObjectTypes(contentTypes);

    return new ResourceQuery(this.getRecentViews)
      .withExtraParams({viewStatFields: ViewStatFields, objectTypes: objectTypes})
      .withFilters(additionalFilterClauses);
  }

  public users(additionalFilterClauses?: ILeafFilterClause[]): ResourceQuery<IUserInfo> {
    const contentTypes = [ExplorableItemTypeValue.view, ExplorableItemTypeValue.metric, ExplorableItemTypeValue.flow];
    const objectTypes = this.getObjectTypes(contentTypes);
    const order: IOrderClause[] = [{ field: OrderKeys.lastAccessedAt, ascending: false}];
    return new ResourceQuery(this.getRecentUsersFetcher)
              .withExtraParams({viewStatFields: ViewStatFields, objectTypes: objectTypes})
              .withOrder(order)
              .withFilters(additionalFilterClauses);
  }

  private getObjectTypes(contentTypes: ReadonlyArray<ExplorableItemType>): string[] {
    const objectTypes = contentTypes.map((contentType) => {
      switch(contentType){
        case 'view':
          return 'VIEW';
        case 'metric':
          return 'METRIC';
        case 'flow':
          return 'FLOW';
        default:
          return '';
      }
    }).filter((value => value.length > 0));

    if (objectTypes.length === 0) {
      return ['VIEW'];
    }

    return objectTypes;
  }
}

export const Recents = new RecentsResource();
